import React, { FunctionComponent, useEffect } from 'react'

interface HeroCarouselArrowProps {
  direction: 'previous' | 'next'
  onClick: () => void
}

const HeroCarouselArrow: FunctionComponent<HeroCarouselArrowProps> = ({
  direction,
  onClick,
}) => {
  const icon = 'cnh-chevron-' + (direction === 'previous' ? 'left' : 'right')

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <button
      className={'controls__arrow controls__arrow--' + direction}
      aria-label={direction + 'slide / item'}
      onClick={onClick}
    >
      <pfe-icon icon={icon} color={'base'} />
    </button>
  )
}

export default HeroCarouselArrow
